<script lang="ts">
import { defineComponent } from "vue";

import aiIconDefault from "@/assets/images/ai-prompt-default.svg";
import aiIconProcessing from "@/assets/images/ai-prompt-processing.svg";
import aiIconResponding from "@/assets/images/ai-prompt-responding.svg";
import { EventBus } from "@/store/eventBus";

export default defineComponent({
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultState: "default" as const,
      currentState: "default",
      stateIconMap: new Map<string, string>([
        ["default", aiIconDefault],
        ["processing", aiIconProcessing],
        ["responding", aiIconResponding],
      ]),
      aiIconDefault,
      aiIconProcessing,
      aiIconResponding,
    };
  },
  mounted() {
    EventBus.on("updatePromptBtnState", (promptState: string) => {
      if (this.stateIconMap.has(promptState)) {
        this.currentState = promptState;
      }
    });
  },
  computed: {
    currentStateDisplay() {
      return this.stateIconMap.get(this.currentState);
    },
  },
  methods: {
    openAiPrompt() {
      if (this.currentState === this.defaultState) {
        window.location.href = "/ai-assistant";
      }
    },
  },
});
</script>

<template>
  <button
    data-cy="ai-prompt-btn"
    class="flex items-center gap-2 p-[0.375rem] xlg:py-3 xlg:pr-4 xlg:pl-3 rounded-[999px] bg-transparent"
    :class="[
      {
        'hover:bg-white-dark active:bg-white-lightest focus:bg-white-dark text-white-lightest hover:text-black active:text-black focus:text-black':
          dark,
        'hover:bg-[#e2e2e2] active:bg-black focus:bg-[#e2e2e2]  text-black active:text-white-lightest':
          !dark,
      },
    ]"
    @click="openAiPrompt"
    @keyup.enter="openAiPrompt"
    @keyup.space="openAiPrompt"
    tabindex="0"
  >
    <img
      :src="currentStateDisplay"
      alt="ai Prompt Icon"
      class="w-8 h-8 xlg:w-6 xlg:h-6"
    />
    <span class="hidden xlg:block font-light">AI Assistant</span>
  </button>
</template>
